import { gql } from '@apollo/client'

export const RESUME_OPTIMIZATIONS = gql`
  mutation ResumeOptimizations($input: OptimizationsInput!) {
    resumeOptimizationsInCompanyStores(input: $input) {
      success
      storeIds
    }
  }
`
